// ShareTrainingCardTestPage.jsx
import React, { useMemo } from 'react';
import ShareTrainingCardPanel from './ShareTrainingCardPanel';

export default function ShareTrainingCardTestPage() {
  const photoUrl = useMemo(() => `${process.env.PUBLIC_URL}/share-test/photo.jpg`, []);
  const mapImageUrl = useMemo(() => `${process.env.PUBLIC_URL}/share-test/map.jpg`, []);

const activity = useMemo(
  () => ({
    type: 'Running',
    name: 'Test Share Card',
    fileId: '1767206825162', // ✅ agrega esto (uno real)
    completed: {
      distance: 10020,
      durationSec: 53 * 60 + 51,
      pace: 5 * 60 + 22,
      tss: 45,
    },
    routePoints: [
      [-33.4372, -70.633],
      [-33.4370, -70.631],
      [-33.4366, -70.628],
      [-33.4360, -70.625],
      [-33.4354, -70.622],
      [-33.4348, -70.619],
      [-33.4344, -70.617],
    ],
  }),
  []
);


  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ marginBottom: 12 }}>🧪 Share Training Card (Test)</h2>
      <p style={{ marginTop: 0, opacity: 0.8 }}>
        Usa imágenes locales para evitar CORS. Prueba “Descargar PNG” en desktop y “Compartir” en mobile.
      </p>

      <ShareTrainingCardPanel
        activity={activity}
        photoUrl={photoUrl}
        mapImageUrl={mapImageUrl}
        onClose={() => window.history.back()}
      />
    </div>
  );
}
